export default {
    bot_description: "Bot tavsifi",
    bot_name: "Bot nomi",
    clinic_account: "Klinika akkaunti",
    clinic_site_link: "Klinikaning veb-saytiga havola",
    code_for_bonus_payment: "Bonus to'lovi uchun kod",
    code_was_not_sent: "Kod yuborilmadi - bemor Telegram botiga ulanishni tekshirib ko'rishi kerak",
    code_was_sent_to_patient_through_bot: "Kod Telegram boti orqali bemorga yuborildi",
    connected_to_telegram_bot: "Telegram botiga ulangan",
    max_bot: "Max bot",
    telegram_bot: "Telegram bot",
    telegram_bot_default_description: "Bot klinika bemorlariga bonuslarni to'plashga va tashriflari haqida dolzarb ma'lumot olishga yordam beradi",
    telegram_bot_instruction_1: "Telegram messenjerini oching, hisobingizga kiring yoki yangisini yarating. Qidiruv maydoniga <code>{'@'}BotFather</code> kiriting va botni tanlang",
    telegram_bot_instruction_2: "<code>/newbot</code> buyrug'ini tanlang yoki kiriting va yuboring",
    telegram_bot_instruction_3: "Botga nom bering - mijozlar bu nomni bot bilan muloqot qilishda ko'rishadi. Botning taxallusi esa – u orqali Telegram’da botni topish mumkin bo‘ladi. Taxallus noyob bo'lishi kerak, ma'lumotlar bazasida mavjudlarini takrorlamasligi va bot so'zi bilan tugashi kerak",
    telegram_bot_instruction_4: "Yaratilgan botdan token qiymatidan nusxa oling, uni quyidagi maydonga joylashtiring va saqlang",
    use_bonuses_by_confirming_through_telegram_bot: "Bonusni Telegram boti orqali tasdiqlash bilan hisobdan chiqarish",
    wrong_code: "Kod noto'g'ri"
}
